import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
  margin-block: 2rem;
`;

export const BlockWrapper = styled.div`
  display: flex;
  flex-direction: column;

  // @media (min-width: 768px) {
  //   gap: 2.5rem;
  //   margin-bottom: 4rem;
  // }

  // @media (min-width: 992px) {
  //   gap: 3rem;
  //   margin-bottom: 5rem;
  // }
`;
